<script lang="ts">
import type { HTMLAttributes } from 'vue'

export type SliderFieldSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

export interface SliderFieldProps {
  class?: HTMLAttributes['class']
  disabled?: boolean
  size?: SliderFieldSize
  error?: boolean | string
}
</script>

<script setup lang="ts">
import { cva } from 'class-variance-authority'
import { cn } from '#ui-kit/lib/utils'

const props = withDefaults(defineProps<SliderFieldProps>(), {
  size: 'md',
})

const fieldVariants = cva('inline-flex items-center w-full rounded-lg text-primal font-display', {
  variants: {
    size: {
      xs: 'h-[24px] px-2',
      sm: 'h-[32px] px-2',
      md: 'h-[40px] px-2',
      lg: 'h-[52px] px-3',
      xl: 'h-[60px] px-4',
    },
  },
})
</script>

<template>
  <div
    :class="
      cn(
        fieldVariants({ size: props.size }),
        props.disabled
          ? 'cursor-not-allowed ring-0 bg-neutral-600/30 ring-neutral-600/60 text-neutral-900/30 **:pointer-events-none'
          : 'cursor-default ring-1 ring-inset ring-neutral-600 focus-within:ring-2 focus-within:ring-primary-500 [&:not(:focus-within):hover]:bg-neutral-600/10',
        props.error && 'ring-error!',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
